import type { Product, SKUListing } from '../types/product'

export function isProductActive(item: SKUListing | Product) {
  return item.isActive && item.isVisibleInPortal
}

export const PRODUCT_STATUS = {
  active: 'active',
  inactive: 'inactive',
  pending: 'pending',
} as const

export function getProductStatus(item: SKUListing | Product) {
  if (!item.isActive) {
    return PRODUCT_STATUS.inactive
  }

  if (!item.isVisibleInPortal) {
    return PRODUCT_STATUS.pending
  }

  return PRODUCT_STATUS.active
}
